import * as Constants from './constants'
import * as Types from './types'

const initialFields = {
  account: 0,
  guid: '',
  name: '',
}
const initialState = {
  fields: initialFields,
  isAccountCreate: false,
  isCreating: false,
}
export const reducer = (state: Types.State = initialState, action: Types.UpdateFieldAction) => {
  switch (action.type) {
    case Constants.CREATE_COMMUNITY_REQUEST:
      return {
        ...state,
        isCreating: true,
      }
    case Constants.CREATE_COMMUNITY_SUCCESS:
    case Constants.CREATE_COMMUNITY_ERROR:
      return {
        ...state,
        isCreating: false,
      }
    case Constants.UPDATE_CREATE_COMMUNITY_FIELD:
      return {
        ...state,
        ...{
          fields: {
            ...state.fields,
            [action.field.name]: action.field.value,
          },
        },
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/pages/create-community/reducer.ts